export default "__VITE_ASSET__Dwanh1zY__"